// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterPopup {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
  /* transform: scale(0.5); */
  transform: scale(0);
  position: fixed;
  z-index: 1005;
  overflow-y: scroll;
  scrollbar-width: none;
  background: var(--clr-gray200);
  /* animation: 0.5s fadeIn; */
  pointer-events: none;
  transition: 0.25s;
}

.filterPopup.show {
  transform: scale(1);
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}

.filterPopupMoreCategory .checkbox-container {
  align-items: flex-start;
}

/* @keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  25% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
} */

.filterPopup__container {
  padding: 1.5em;
}

.filterPopup::-webkit-scrollbar {
  display: none;
}

.filterPopup__header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1em;
  border-bottom: 0.1rem solid var(--clr-gray500);
}

.filterPopup__close {
  display: grid;
  place-items: center;
  position: relative;
  padding: 1em;
  border-radius: 50%;
  width: -moz-fit-content;
  width: fit-content;
  transform: scale(0.6);
  cursor: pointer;
  border: 0.15rem solid var(--clr-dark);
  background: transparent;
}

.filterPopup__close i {
  display: block;
  left: 50%;
  transform: translateX(-83%);
  position: absolute;
  margin-bottom: -0.5rem;
}

.filterPopup__categoryTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bolder;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

.filterPopup__categoryTitle span {
  font-size: 0.9rem;
  color: var(--clr-primary);
  font-weight: 500;
  text-transform: uppercase;
}

.filterPopup__action {
  position: sticky;
  bottom: 0;
  padding: 1em;
  background: var(--clr-gray);
}

.filterPopup__action button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 0.75em;
}

.filterPopup__action > button:first-child {
  color: var(--clr-primary);
  background: transparent;
}
.filterPopup__action > button:last-child svg {
  width: 1.25rem;
  margin-left: 0.5rem;
}

@media (min-width: 768px) {
  .filterPopup {
    width: 50%;
    height: 80%;
    margin: auto;
    border-radius: 1em;
    box-shadow: 0 0.75rem 1rem #0002;

    /* border: 0.1rem solid var(--clr-gray800); */
  }

  .filterPopup__categoryTitle span {
    display: none;
  }

  .filterPopup__action {
    display: flex;
    justify-content: space-between;
  }

  .filterPopup__action button {
    max-width: 15rem;
    padding-inline: 1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FilterPopup/FilterPopup.css"],"names":[],"mappings":"AAAA;EACE,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;;IAEhC,6CAA6C;EAC/C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".filterPopup {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  visibility: hidden;\n  /* transform: scale(0.5); */\n  transform: scale(0);\n  position: fixed;\n  z-index: 1005;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  background: var(--clr-gray200);\n  /* animation: 0.5s fadeIn; */\n  pointer-events: none;\n  transition: 0.25s;\n}\n\n.filterPopup.show {\n  transform: scale(1);\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.filterPopupMoreCategory .checkbox-container {\n  align-items: flex-start;\n}\n\n/* @keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n} */\n\n.filterPopup__container {\n  padding: 1.5em;\n}\n\n.filterPopup::-webkit-scrollbar {\n  display: none;\n}\n\n.filterPopup__header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 1em;\n  border-bottom: 0.1rem solid var(--clr-gray500);\n}\n\n.filterPopup__close {\n  display: grid;\n  place-items: center;\n  position: relative;\n  padding: 1em;\n  border-radius: 50%;\n  width: fit-content;\n  transform: scale(0.6);\n  cursor: pointer;\n  border: 0.15rem solid var(--clr-dark);\n  background: transparent;\n}\n\n.filterPopup__close i {\n  display: block;\n  left: 50%;\n  transform: translateX(-83%);\n  position: absolute;\n  margin-bottom: -0.5rem;\n}\n\n.filterPopup__categoryTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: bolder;\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n}\n\n.filterPopup__categoryTitle span {\n  font-size: 0.9rem;\n  color: var(--clr-primary);\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.filterPopup__action {\n  position: sticky;\n  bottom: 0;\n  padding: 1em;\n  background: var(--clr-gray);\n}\n\n.filterPopup__action button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border-radius: 0.75em;\n}\n\n.filterPopup__action > button:first-child {\n  color: var(--clr-primary);\n  background: transparent;\n}\n.filterPopup__action > button:last-child svg {\n  width: 1.25rem;\n  margin-left: 0.5rem;\n}\n\n@media (min-width: 768px) {\n  .filterPopup {\n    width: 50%;\n    height: 80%;\n    margin: auto;\n    border-radius: 1em;\n    box-shadow: 0 0.75rem 1rem #0002;\n\n    /* border: 0.1rem solid var(--clr-gray800); */\n  }\n\n  .filterPopup__categoryTitle span {\n    display: none;\n  }\n\n  .filterPopup__action {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .filterPopup__action button {\n    max-width: 15rem;\n    padding-inline: 1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
